/**
 * Interrupteur.
 *
 * `role="switch"` et non un groupe de deux boutons : il n'y a pas deux options
 * à choisir, il y a une option à activer. Les lecteurs d'écran annoncent alors
 * « activé / désactivé » au lieu de « bouton pressé », et la touche Espace
 * bascule sans qu'on ait à la câbler.
 *
 * Le libellé est cliquable avec le bouton — la cible est petite, et personne ne
 * vise un rail de 34 px quand le texte est juste à côté.
 */

interface ToggleSwitchProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Précision sous le libellé — ce que l'activation change. */
  hint?: string;
}

export function ToggleSwitch({ label, checked, onChange, hint }: ToggleSwitchProps) {
  return (
    <div className="switch">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        className="switch__track"
        onClick={() => onChange(!checked)}
      >
        <span className="switch__knob" aria-hidden="true" />
      </button>

      <span className="switch__text">
        {/* Le texte bascule aussi l'interrupteur : la cible utile est le
            libelle, pas le rail. */}
        <button type="button" className="switch__label" onClick={() => onChange(!checked)}>
          {label}
        </button>
        {hint && <span className="switch__hint">{hint}</span>}
      </span>
    </div>
  );
}
